type Props = {
  label: string;
  requiredAmount: string;
  className?: string;
  size?: "sm" | "md" | "lg" | "xl" | "xxl";
};
const RequiredAmount = ({
  label,
  requiredAmount,
  className,
  size = "sm",
}: Props) => (
  <span className={`${className || ""} fs-${size}`}>
    <span className={`fs-${size}`}>{label}</span> &nbsp;
    <span className={`text-primary fw-bold fs-${size}`} dir="auto">
      {requiredAmount}
    </span>
  </span>
);
export default RequiredAmount;
